import { gql } from 'graphql-request'

export const BUY_BOOK_PROMOTION = gql`
  mutation Mutation($buyBookInput: BuyBookInput!) {
    buyBook(buyBookInput: $buyBookInput) {
      transactionId
    }
  }
`
